import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_36 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'assets'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewPropertyType')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.propertyTypeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('propertyTypeNameArLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('propertyTypeNameEnLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('propertyCategory')), 1),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-1 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.translate('propertyCategoryTooltip')
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "propertyCategoryId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedPropertyCategory,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPropertyCategory) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.translate('selectPropertyCategory')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypesCategories, (propertyCategory) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: propertyCategory.id,
                            value: propertyCategory.id
                          }, _toDisplayString(propertyCategory.title), 9, _hoisted_23))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_ErrorMessage, { name: "propertyCategoryId" })
                      ])
                    ])
                  ])
                ]),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('isAd')) + ": ", 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isAd",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('isRegisteredTrades')) + ": ", 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isRegisteredTrades",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_38, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_39
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}